import React, { useState, useEffect } from "react";
import SearchField from "../../components/textfield/searchField";
import "../../assets/styles/components/table.scss";
import { mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { Table, Popover, Modal } from "antd";
import { numberWithCommas } from "../../helpers/functions";
import HeaderBar from "../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
const Cashier = () => {
  const history = useHistory();
  const [data, setData] = useState<any>([]);
  const [listSearch, setListSearch] = useState<any>([]);
  const [textSearch, setTextSearch] = useState<string>("");
  const [page, setPage] = useState(1);
  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      key: 1,
      render: (value: any, item: any, index: number) =>
        (page - 1) * 10 + (index + 1),
    },
    {
      title: "รหัสการขาย<br/>SO",
      colSpan: 1,
      width: "25%",
      key: 2,
      render: (data: any) => (
        <Popover
          content={
            <div>
              {data?.items.map((item: any, index: number) => (
                <p>{item?.name}</p>
              ))}
            </div>
          }
          title=""
          placement="right"
        >
          {data?.code}
        </Popover>
      ),
    },
    {
      title: "รหัสลูกค้า<br/>CN",
      colSpan: 1,
      width: "20%",
      key: 3,
      render: (data: any) => <>{data?.memberData?.code}</>,
    },
    {
      title: "ชื่อ-นามสกุล<br/>Name - Surname",
      colSpan: 1,
      width: "20%",
      key: 4,
      render: (data: any) => (
        <>
          {data?.memberData?.firstName} {data?.memberData?.lastName}
        </>
      ),
    },
    {
      title: "เลขที่ใบยา<br/>Ref.VN",
      dataIndex: "vn",
      colSpan: 1,
      width: "10%",
      key: 5,
    },
    {
      title: "สาขา<br/>Branch",
      colSpan: 1,
      width: "10%",
      key: 6,
      render: (data: any) => <>{data?.branchData?.name}</>,
    },
    {
      title: "วันที่ซื้อ<br/>Purchase Date",
      colSpan: 1,
      width: "10%",
      key: 7,
      render: (data: any) => (
        <div style={{ width: "120px", textAlign: "center" }}>
          {moment(data?.updatedAt).format("DD-MM-YYYY")}
        </div>
      ),
    },
    {
      title: "ราคาขาย<br/>Sale Price",
      colSpan: 1,
      width: "150px",
      key: 8,
      render: (data: any) => (
        <div style={{ width: "120px", textAlign: "right" }}>
          {numberWithCommas(data.balanceAfterAllDiscount, 2)}
        </div>
      ),
    },
    {
      title: "ชำระแล้ว<br/>Paid",
      colSpan: 1,
      width: "10%",
      key: 9,
      render: (data: any) => (
        <div style={{ textAlign: "right" }}>
          {numberWithCommas(data.paidCalculate, 2)}
        </div>
      ),
    },
    {
      title: "คงเหลือ<br/>Balance",
      colSpan: 1,
      width: "10%",
      key: 9,
      render: (data: any) => (
        <div style={{ textAlign: "right" }}>
          {numberWithCommas(
            data.balanceAfterAllDiscount - data.paidCalculate,
            2
          )}
        </div>
      ),
    },
    {
      title: "สถานะ<br/>Status",
      colSpan: 1,
      width: "10%",
      key: 10,
      render(data: any) {
        return {
          props: {
            style: {
              background:
                data?.statusPayment === "deposit"
                  ? "#FEEFC7"
                  : data?.statusPayment === "paid_full"
                    ? "#C7F0D8"
                    : "#FFCDCD",
              align: "center" as const,
            },
          },
          children: (
            <div
              style={{
                color:
                  data?.statusPayment === "deposit"
                    ? "#F3A086"
                    : data?.statusPayment === "paid_full"
                      ? "#4D7E7F"
                      : "#E76464",

                borderColor: "green",
                textAlign: "center",
              }}
              onClick={() => {
                history.push(`/cashier/${data._id}`);
              }}
            >
              {data?.statusPayment === "deposit"
                ? "Deposit"
                : data?.statusPayment === "paid_full"
                  ? "Paid Full"
                  : "Unpaid"}
            </div>
          ),
        };
      },
    },
    {
      title: "ประวัติ<br/>History",
      colSpan: 3,
      width: "10%",
      align: "center" as const,
      key: 11,
      render: (data: any) => (
        <div
          onClick={() => {
            if (
              data?.statusPayment === "paid_full" ||
              data?.statusPayment === "deposit"
            ) {
              history.push(`/cashier/${data._id}/history`);
            } else {
              history.push(`/cashier/${data._id}`);
            }
          }}
        >
          <Icon
            path={mdiEyeOutline}
            size="20"
            color={`${data?.statusPayment === "paid_full" ||
              data?.statusPayment === "deposit"
              ? "#5BAEA9"
              : "#eee"
              }`}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    getSearch();
  }, [textSearch]);

  useEffect(() => {
    getCashier();
  }, []);
  const getSearch = async () => {
    if (textSearch.length >= 1) {
      let calculateData = [];
      let baseData = data;
      for (let i = 0; i < baseData.length; i++) {
        if (
          baseData[i]?.branchData?.name.substr(0, textSearch).toUpperCase() ===
          textSearch.toUpperCase()
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]?.branchData?.name
            .toUpperCase()
            .indexOf(textSearch.toUpperCase()) > -1
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]?.memberData?.firstName
            .substr(0, textSearch)
            .toUpperCase() === textSearch.toUpperCase()
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]?.memberData?.firstName
            .toUpperCase()
            .indexOf(textSearch.toUpperCase()) > -1
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]?.memberData?.lastName
            .substr(0, textSearch)
            .toUpperCase() === textSearch.toUpperCase()
        ) {
          calculateData.push(baseData[i]);
        } else if (
          baseData[i]?.memberData?.lastName
            .toUpperCase()
            .indexOf(textSearch.toUpperCase()) > -1
        ) {
          calculateData.push(baseData[i]);
        }
      }
      setListSearch(calculateData);
    } else {
      setListSearch(data);
    }
  };
  const getCashier = () => {
    axios.get(`/cashier`).then((res) => {
      setData(res?.data?.data);
    }).then(() => {
      let table_cell = document.querySelectorAll("th.ant-table-cell");
      for (let i = 0; i < table_cell.length; i++) {
        let node : any = table_cell[i];
        if (node) node.innerHTML = node.innerText;
      }
    });
  };

  return (
    <div>
      <HeaderBar title="CASHIER" />
      <div style={{ margin: "10px 80px" }}>
        <SearchField
          placeholder="Search for customer (CN, Name)"
          color="#FFF"
          onChange={(e: any) => setTextSearch(e.target.value)}
        />
        <div style={{ marginTop: "20px" }}>
          <Table
            columns={columns}
            dataSource={listSearch.length > 0 ? listSearch : data}
            bordered
            scroll={{ x: 100 }}
            rowKey="_id"
            pagination={{
              onChange(current) {
                setPage(current);
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default Cashier;
